import { render, staticRenderFns } from "./homeworkIndex.vue?vue&type=template&id=6965d921&scoped=true"
import script from "./homeworkIndex.vue?vue&type=script&lang=js"
export * from "./homeworkIndex.vue?vue&type=script&lang=js"
import style0 from "./homeworkIndex.vue?vue&type=style&index=0&id=6965d921&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6965d921",
  null
  
)

export default component.exports